import React from "react"
import { Moon, Sun } from "react-feather"
import { UncontrolledTooltip } from "reactstrap"
import { useTheme } from "../../theme/ThemeProvider"

/**
 * Light/dark switch for the header. Rendered as a real `switch` so it is keyboard operable and
 * announces its state; all of the look lives in styles/theme/_theme-toggle.scss.
 */
const ThemeSwitch = () => {
  const { isDark, toggleTheme } = useTheme()

  return (
    <>
      <button
        type='button'
        id='app-theme-switch'
        className='theme-switch'
        role='switch'
        aria-checked={isDark}
        aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
        onClick={toggleTheme}
      >
        <span className='theme-switch__icon theme-switch__icon--sun'>
          <Sun size={14} strokeWidth={2.5} />
        </span>
        <span className='theme-switch__icon theme-switch__icon--moon'>
          <Moon size={14} strokeWidth={2.5} />
        </span>
        <span className='theme-switch__knob' />
      </button>
      <UncontrolledTooltip placement='bottom' target='app-theme-switch'>
        {isDark ? "Light mode" : "Dark mode"}
      </UncontrolledTooltip>
    </>
  )
}

export default ThemeSwitch
